import React from 'react'
import ScheduleBenefits from '../common_components/ScheduleBenefits'

class SummaryHeader extends React.Component {
  onHelpfulCheck (data) {
    this.props.onHelpfulCheck(this.props.date, data)
  }

  render () {
    return (
      <div className='summary-header'>
        <div className='summary-date'>
          <span className='summary-header-date'>{moment(this.props.date).format("MMMM D YYYY")}</span>
          <span className='summary-header-day'>{moment(this.props.date).format(" - dddd")}</span>
        </div>
        <ScheduleBenefits
          benefits={this.props.benefits}
          handleItemClick={this.props.handleItemClick}
          display_modal={this.props.display_modal}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.props.handleJustLookingClick}
        />
      </div>
    )
  }
}

export default SummaryHeader;